import { create } from 'zustand';

import { TreeSpaceRef } from '../types/data-room.types';

export type PreviewedFile = {
  fileId: string;
  fileName: string;
  space: TreeSpaceRef;
};

type FilePreviewStoreState = {
  close: () => void;
  file: null | PreviewedFile;
  open: (file: PreviewedFile) => void;
};

/**
 * Which file the preview is showing, if any — 20.2.3's viewer.
 *
 * A store rather than state on a page because the viewer is opened from six places that have no
 * component between them: both browsers, the recipient's room, a visitor's timeline, the Most
 * Viewed card and the search results. One overlay is mounted once, at the module's root, and they
 * all ask for it the same way.
 */
export const FilePreviewStore = create<FilePreviewStoreState>((set) => ({
  close: () => set({ file: null }),
  file: null,
  open: (file) => set({ file }),
}));
